var _desc, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPartnerStreamlineFlex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "-0.645 -0.645 18 18",
    id: "Partner--Streamline-Flex",
    height: 18,
    width: 18,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n    Partner Streamline Icon: https://streamlinehq.com\n  ")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "partner--partnership-alliance-shared",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.29
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.0 12.55a4.2 4.2 0 1 1 0 -8.4 4.2 4.2 0 0 1 0 8.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.71 12.55a4.2 4.2 0 1 1 0 -8.4 4.2 4.2 0 0 1 0 8.4Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPartnerStreamlineFlex);
export default __webpack_public_path__ + "static/media/Partner--Streamline-Flex.595f216d8df88b9fda304f9b1d4a67f4.svg";
export { ForwardRef as ReactComponent };